/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import "@fontsource/roboto";
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { truncate } from "fs/promises";

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

function getBase64Image(img: Blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

const FichaNotificacaoProdutosBaixaQualidadePdf = async (dados?: any) => {
    const imageBlob = await fetch('/img/logo/InsigniaAngola.png').then(res => res.blob());
    const imageBase64 = await getBase64Image(imageBlob) as string;

    // pdfMake.fonts = {
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //     }
    // };

    const docDefinition: TDocumentDefinitions = {
        pageSize: 'A4',
        pageMargins: [30, 30, 30, 30],
        content: [
            // Cabeçalho com logo e título
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                stack: [
                                    {
                                        image: imageBase64,
                                        width: 35,
                                        alignment: 'center',
                                        margin: [0, 5, 0, 5]
                                    },
                                    {
                                        text: 'MINISTÉRIO DA SAÚDE',
                                        alignment: 'center',
                                        bold: true,
                                        fontSize: 10
                                    },
                                    {
                                        text: 'AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIA DE SAÚDE',
                                        alignment: 'center',
                                        fontSize: 8
                                    },
                                    {
                                        text: 'DEPARTAMENTO DE FARMACOVIGILÂNCIA E REMÉDIOS TRADICIONAIS',
                                        alignment: 'center',
                                        fontSize: 8
                                    }
                                ],
                                margin: [5, 5, 5, 5]
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 6]
            },

            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'FICHA DE NOTIFICAÇÃO DE SUSPEITA DE PRODUTOS COM BAIXA QUALIDADE', border: [false, false, false, false],
                                alignment: 'center',
                                bold: true,
                                fontSize: 10,
                                fillColor: '#B4C7E7',
                                margin: [0, 5, 0, 5]
                            },
                        ],
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                },
                margin: [0, 0, 0, 3]
            },

            {
                text: 'ENTIDADE SANITÁRIA',
                alignment: 'center',
                bold: true,
                fontSize: 10,
                margin: [0, 2, 0, 3]
            },
            {
                table: {
                    widths: ['*', 100],
                    body: [
                        [
                            { text: 'Unidade Sanitária/Farmácia', fontSize: 8, border: [true, true, false, false] },
                            { text: 'Província', fontSize: 8, border: [false, true, true, false] }
                        ],
                        [
                            { text: `${dados?.unidadeSanitaria?.nome}`, fontSize: 8, border: [true, false, false, true], margin: [0, 2, 0, 0] },
                            { text: `${dados?.unidadeSanitaria?.provincia}`, fontSize: 8, border: [false, false, true, true], margin: [0, 2, 0, 0] },

                        ]
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                },
                margin: [0, 0, 0, 5]
            },
            {
                table: {
                    widths: ['*', 80, 60, 80],
                    body: [
                        [
                            { text: 'Endereço da U.Sanitária/farmácia, Distrito', fontSize: 8, border: [true, true, false, false] },
                            { text: 'Bairro', fontSize: 8, border: [false, true, false, false] },
                            { text: 'Rua', fontSize: 8, border: [false, true, false, false] },
                            { text: 'Telefone nº', fontSize: 8, border: [false, true, true, false] }
                        ],
                        [
                            { text: `${dados?.unidadeSanitaria?.municipio ?? ''}`, fontSize: 8, border: [true, false, false, false], margin: [0, 1, 0, 0] },
                            { text: `${dados?.unidadeSanitaria?.bairro ?? ''}`, fontSize: 8, border: [false, false, false, false], margin: [0, 1, 0, 0] },
                            { text: `${dados?.unidadeSanitaria?.rua ?? ''}`, fontSize: 8, border: [false, false, false, false], margin: [0, 1, 0, 0] },
                            { text: `${dados?.unidadeSanitaria?.telefone ?? ''}`, fontSize: 8, border: [false, false, true, false], margin: [0, 1, 0, 0] }
                        ],
                        [
                            { text: `E-mail: ${dados?.unidadeSanitaria?.email ?? ''}`, fontSize: 8, border: [true, false, true, true], colSpan: 4, margin: [0, 2, 0, 0] },
                            {}, {}, {}
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 5]
            },

            // IDENTIFICAÇÃO DO PRODUTO
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'IDENTIFICAÇÃO DO PRODUTO', border: [false, false, false, false],
                                alignment: 'center',
                                bold: true,
                                fontSize: 11,
                                fillColor: '#B4C7E7',
                                margin: [0, 4, 0, 4]
                            },
                        ],
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                },
                margin: [0, 0, 0, 0]
            },

            {
                table: {
                    widths: ['*', '*'],
                    body: [
                        [
                            { text: `Nome do produto DCI: ${dados?.identificacaoProducto[0]?.nomeDCI ?? ''}`, fontSize: 8, border: [true, true, true, false] },
                            { text: `Nome comercial: ${dados?.identificacaoProducto[0]?.nomeCormecial ?? ''}`, fontSize: 8, border: [false, true, true, false] }
                        ],
                        [
                            { text: `Número de lote: ${dados?.identificacaoProducto[0]?.numeroLote ?? ''}`, fontSize: 8, border: [true, true, true, false] },
                            { text: `Data de fabrico: ${new Date(dados?.identificacaoProducto[0]?.dataFabrico).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}   Data de expiração: ${new Date(dados?.identificacaoProducto[0]?.dataExpiracao).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}`, fontSize: 8, border: [false, true, true, false] }
                        ],
                        [
                            { text: `Nome do fabricante: ${dados?.identificacaoProducto[0]?.nomeFabricante ?? ''}`, fontSize: 8, border: [true, true, true, false] },
                            { text: `País de origem: ${dados?.identificacaoProducto[0]?.paisOrigem ?? ''}`, fontSize: 8, border: [false, true, true, false] }
                        ],
                        [
                            { text: `Nome do distribuidor/Fornecedor: ${dados?.identificacaoProducto[0]?.nomeFornecedor ?? ''}`, fontSize: 8, border: [true, true, true, true] },
                            { text: `Data da recepção: ${new Date(dados?.identificacaoProducto[0]?.dataRecepcao).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}`, fontSize: 8, border: [false, true, true, true] }
                        ],
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 5]
            },
            {
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                stack: [
                                    {
                                        text: 'Apresentação do Produto', border: [false, false, false, false],
                                        alignment: 'center',
                                        bold: true,
                                        fontSize: 10,
                                        margin: [0, 5, 0, 5]
                                    },
                                    {
                                        text: '(marcar o quadro apropriado)',
                                        italics: true,
                                        fontSize: 8,
                                        alignment: 'center',
                                        margin: [0, 0, 0, 5]
                                    },
                                ], border: [false, false, false, false],
                                margin: [0, 0, 0, 0],
                                fillColor: '#B4C7E7',
                            },
                            {
                                stack: [
                                    {
                                        text: 'Defeitos', border: [false, false, false, false],
                                        alignment: 'center',
                                        bold: true,
                                        fontSize: 10,
                                        margin: [0, 3, 0, 0]
                                    },
                                    {
                                        text: '(marcar o quadro apropriado)',
                                        italics: true,
                                        fontSize: 8,
                                        alignment: 'center',
                                        margin: [0, 0, 0, 5]
                                    },
                                ], border: [false, false, false, false],
                                margin: [0, 0, 0, 0],
                                fillColor: '#B4C7E7',
                            },
                        ],
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                },
                margin: [0, 0, 0, 0]
            },

            {
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                stack: [
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.a === true ? 'X' : ''} ] Comprimidos/cápsulas orais`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.b === true ? 'X' : ''} ] Suspensão, xaropes`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.c === true ? 'X' : ''} ] Injecção`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.d === true ? 'X' : ''} ] Diluente`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.e === true ? 'X' : ''} ] Pó para reconstituição da suspensão`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.f === true ? 'X' : ''} ] Pó para reconstituição de injectáveis`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.g === true ? 'X' : ''} ] Gotas oftálmicas`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.h === true ? 'X' : ''} ] Gotas nasais`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.i === true ? 'X' : ''} ] Gotas auriculares`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.j === true ? 'X' : ''} ] Nebulizadores`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.k === true ? 'X' : ''} ] Creme, pomadas, pastas, linimentos`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.outros !== '' ? 'X' : ''} ] outros: ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.outros}`, fontSize: 8, margin: [5, 2, 0, 5] }
                                ],
                                margin: [5, 5, 5, 5]
                            },
                            {
                                stack: [
                                    { text: `[ ${dados?.identificacaoProducto[0]?.defeitos?.a === true ? 'X' : ''} ] separação`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.defeitos?.b === true ? 'X' : ''} ] Solidificação (endurece)`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.defeitos?.c === true ? 'X' : ''} ] Esfarelamento`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.defeitos?.d === true ? 'X' : ''} ] Moldura defeituosa`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.defeitos?.e === true ? 'X' : ''} ] Mudança de Cheiro`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.defeitos?.f === true ? 'X' : ''} ] Mudança de cor`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.defeitos?.g === true ? 'X' : ''} ] Rotulagem defeituosa`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.defeitos?.h === true ? 'X' : ''} ] Acondicionamento defeituoso`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.defeitos?.i === true ? 'X' : ''} ] Rotulagem e prospecto deficiente`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.outros !== '' ? 'X' : ''}  ] outros`, fontSize: 8, margin: [5, 2, 0, 2] },
                                    { text: `[ ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.outros !== '' ? 'X' : ''} ] outros: ${dados?.identificacaoProducto[0]?.apresentacaoProducto?.outros}`, fontSize: 8, margin: [5, 2, 0, 5] }
                                ],
                                margin: [5, 5, 5, 5]
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 5]
            },

            // CONDIÇÕES DE ARMAZENAMENTO
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'CONDIÇÕES DE ARMAZENAMENTO', border: [false, false, false, false],
                                alignment: 'center',
                                bold: true,
                                fontSize: 10,
                                fillColor: '#B4C7E7',
                                margin: [0, 4, 0, 4]
                            },
                        ],
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                },
                margin: [0, 0, 0, 0]
            },
            {
                table: {
                    widths: ['*', 30, 30, '*'],
                    body: [
                        [
                            { text: '', border: [true, true, false, false] },
                            { text: 'Sim', fontSize: 8, alignment: 'center', border: [true, true, false, true] },
                            { text: 'Não', fontSize: 8, alignment: 'center', border: [true, true, true, true] },
                            { text: 'Outros detalhes se necessário', fontSize: 8, border: [false, true, true, true], rowSpan: 6 }
                        ],
                        [
                            { text: 'O produto requer refrigeração?', fontSize: 8, border: [true, true, false, true] },
                            { text: `${dados?.conducoesArmazenamento?.a?.resposta === "Sim" ? dados?.conducoesArmazenamento?.a?.resposta : ''}`, fontSize: 8, border: [true, false, false, true], alignment:'center' },
                            { text: `${dados?.conducoesArmazenamento?.a?.resposta === "Não" ? dados?.conducoesArmazenamento?.a?.resposta : ''}`, fontSize: 8, border: [true, false, true, true], alignment:'center' }, 
                            { text: `${dados?.conducoesArmazenamento.a.outrosDetalhes}`, border: [false, false, false, false], fontSize: 8, margin: [1, 1, 1, 1] }
                        ],
                        [
                            { text: 'O produto ja tem sido usado na unidade sanitaria?', fontSize: 8, border: [true, false, false, true] },
                            { text: `${dados?.conducoesArmazenamento?.b?.resposta === "Sim" ? dados?.conducoesArmazenamento?.b?.resposta : ''}`, fontSize: 8, border: [true, false, false, true], alignment:'center' },
                            { text: `${dados?.conducoesArmazenamento?.b?.resposta === "Não" ? dados?.conducoesArmazenamento?.b?.resposta : ''}`, fontSize: 8, border: [true, false, true, true], alignment:'center' },
                            { text: '', border: [false, false, false, false] }
                        ],
                        [
                            { text: 'O produto foi entregue e devolvido pelo cliente/paciente?', fontSize: 8, border: [true, false, false, true] },
                            { text: `${dados?.conducoesArmazenamento?.c?.resposta === "Sim" ? dados?.conducoesArmazenamento?.c?.resposta : ''}`, fontSize: 8, border: [true, false, false, true], alignment:'center' },
                            { text: `${dados?.conducoesArmazenamento?.c?.resposta === "Não" ? dados?.conducoesArmazenamento?.c?.resposta : ''}`, fontSize: 8, border: [true, false, true, true], alignment:'center' },
                            { text: '', border: [false, false, false, false] }
                        ],
                        [
                            { text: 'O defeito foi detectado pela entidade sanitária?', fontSize: 8, border: [true, false, false, true] },
                            { text: `${dados?.conducoesArmazenamento?.d?.resposta === "Sim" ? dados?.conducoesArmazenamento?.d?.resposta : ''}`, fontSize: 8, border: [true, false, false, true], alignment:'center' },
                            { text: `${dados?.conducoesArmazenamento?.d?.resposta === "Não" ? dados?.conducoesArmazenamento?.d?.resposta : ''}`, fontSize: 8, border: [true, false, true, true], alignment:'center' },
                            { text: '', border: [false, false, false, false] }
                        ],
                        [
                            { text: 'O Produto está armazenado de acordo as instruções, de Boas Práticas de Armazenamento?', fontSize: 8, border: [true, false, false, true] },
                            { text: `${dados?.conducoesArmazenamento?.e?.resposta === "Sim" ? dados?.conducoesArmazenamento?.e?.resposta : ''}`, fontSize: 8, border: [true, false, false, true], alignment:'center' },
                            { text: `${dados?.conducoesArmazenamento?.e?.resposta === "Não" ? dados?.conducoesArmazenamento?.e?.resposta : ''}`, fontSize: 8, border: [true, false, true, true], alignment:'center'},
                            { text: '', border: [false, false, false, false] }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 5]
            },

            // Dados do notificador
            {
                table: {
                    widths: [120, '*', '*', '*', '*'],
                    body: [
                        [
                            { text: 'Nome e apelido do notificador', fontSize: 8, alignment: 'center', bold: true },
                            { text: 'Categoria profissional', fontSize: 8, alignment: 'center', bold: true },
                            { text: 'Telef', fontSize: 8, alignment: 'center', bold: true },
                            { text: 'Email', fontSize: 8, alignment: 'center', bold: true },
                            { text: 'Data Notificação', fontSize: 8, alignment: 'center', bold: true }
                        ],
                        [
                            { text: `${dados?.notificador?.nome}`, fontSize: 8, margin: [0, 2, 0, 0], alignment: 'center', },
                            { text: `${dados?.notificador?.categoriaProfissional ?? ''}`, fontSize: 8, margin: [0, 2, 0, 0], alignment: 'center', },
                            { text: `${dados?.notificador?.tel ?? ''}`, fontSize: 8, margin: [0, 2, 0, 0], alignment: 'center', },
                            { text: `${dados?.notificador?.email ?? ''}`, fontSize: 8, margin: [0, 2, 0, 0], alignment: 'center', },
                            { text: `${new Date(dados?.dataNotificacao).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}`, fontSize: 8, margin: [0, 3, 0, 0], alignment: 'center', }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 5]
            },

            // Observações
            {
                text: 'OBS: enviar o formulário preenchido para farmácia (se de unidade hospitalar se tratar), ou ao Departamento de Farmacovigilância e Remédios Tradicionais.',
                fontSize: 8,
                margin: [0, 3, 0, 5]
            },
            {
                text: 'Participe da Notificação de Produtos de Baixa Qualidade para garantir o uso de medicamentos de qualidade e seguros no País.',
                fontSize: 8,
                bold: true,
                margin: [0, 2, 0, 5]
            },
            {
                text: '',
                fontSize: 8,
                alignment: 'justify'
            }
        ],
        footer: (currentPage, pageCount) => {
            const footerContent: any[] = [
                {
                    columns: [
                        {
                            stack: [
                                { text: 'Endereço: Rua Dr Américo Boavida nº83,1ºandar, Ingombota. Email: farmacovigilanciangola@hotmail.com, telefone nº 222 396 885', style: '', margin: [0, 0, 0, 0], bold: false, fontSize: 8.5, },
                                { text: 'Gerado pelo Gestor - Armed', style: '', margin: [0, 0, 0, 0], bold: true, italics: true },
                            ],
                            width: '100%',
                            alignment: 'left'
                        },

                    ],
                    fontSize: 8,
                    margin: [30, 0, 0, 0],
                }
            ];

            return footerContent;
        },

        styles: {
            tableHeader: {
                bold: true,
                fontSize: 10,
                fillColor: '#e0e0e0'
            }
        },
        defaultStyle: {
            font: 'Roboto',
        }
    };

    pdfMake.createPdf(docDefinition).open();
};

export {
    FichaNotificacaoProdutosBaixaQualidadePdf,
};